<template>
<body class="text-center centrarBody">
  <!-- para mandar correo con rfc-->
  <div>
    <v-row>
      <v-col cols="12">
        <h1 class="mt-5">Recuperar contraseña de acceso</h1>
      </v-col>
      <v-col cols="12">
        <h5 class="mt-5">Ingresa tus datos de acceso</h5>
      </v-col>
    </v-row>
    <div class="centrarBody">
    <v-form ref="form" v-model="formularioValido">
      <v-row align="center" justify="center" row wrap>
        <v-col cols="12">
          <v-row align="center" justify="start" class="reduce-down">
            <v-col cols="12" md="3" lg="2">
              <p class="text-start title font-weight-bold mb-0" style="font-size:1.02rem !important;line-height: 1.2rem;">RFC<b style="color: #5DC00A"> *</b></p>
            </v-col>
            <v-col cols="12" md="9" lg="10">
              <v-text-field
                v-model="rfc"
                :rules="[nameRules.rfcVacio, nameRules.rfcValido]"
                class="big-input"
                outlined dense
                hide-details="auto"
                autocomplete="new-password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <my-captcha :callSuccess="captchaOk2" color="green" mode="math" resolve="text" style="margin: auto;" :key="rerender"></my-captcha>
        </v-col>
         <v-col cols="12" v-if="captchaerror">
            <v-alert type="error">
              Debes completar la operación para continuar
            </v-alert>
        </v-col>
        <v-col cols="12">
          <v-btn
            :disabled="!formularioValido"
            class="white--text mb-5 btn-new"
            block
            x-large
            @click="recuperar"
          >Recuperar</v-btn>
        </v-col>
      </v-row>
    </v-form>
    </div>
  </div>

  <!------------ Dialogo de carga  ----------->
  <v-dialog
    v-model="dialogLoaging"
    persistent
    width="300"
    >
      <v-card
      style="background: #074D43; color: #ffffff;"
      dark
      >
      <v-card-text>
        Porfavor espere
        <v-progress-linear
        indeterminate
        color="white"
        class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!------------ Dialogo mensajes generales  ----------->
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>

        <v-card-text class="pt-5">
          {{text}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="green--text text--darken-3"
            text
            @click="dialog = false;"
          >
            aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</body>
</template>

<script>

  import axios from "axios";
  import myCaptcha from 'vue-captcha';
  import { mapGetters } from "vuex";

export default {
  components: {
    'my-captcha': myCaptcha,
  },
  data() {
    return {
      rerender: 0,
      captcha: false,
      captchaerror: false,
      dialog: false,
      text: '',
      dialog2: false,
      text2: '',
      dialog3: false,
      text3: '',
      dialogLoaging: false,
      mostrarCambiarPass: false,
      nombre: '',
      formularioValido: false,
      show1: false,
      show2: false,
      password: '',
      password2: '',
      token: '',
      rfc: '',
      nameRules: {
        rfcVacio: v => !!v || "RFC requerido",
        rfcValido: v =>
          /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/.test(
            v
          ) || "Ingrese un RFC valido",
        contrasenaVacia: v => !!v || "Contraseña requerida"
      }
    };
  },
  computed: {
    ...mapGetters(["urlAxios"]),
  },
  mounted: function(){
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });	
  },
  watch: {
    dialog() {
      this.switchDialogoChat();
    }
  },
  methods: {
    captchaOk2 () {
	    this.captcha = true;
	    this.captchaerror = false;
	  },
    switchDialogoChat() {
      var chat = document.getElementById('calixta-badge');
      chat.style.display = (chat.style.display == 'block') ? 'none' : 'block';
    },
    recuperar(){
      if(this.captcha){
        this.dialogLoaging = true;
        const params = new URLSearchParams();
        params.append("rfc", this.rfc);
        axios({
          method: "POST",
          url: this.urlAxios+"kiosco/initreestablecercontrasena",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: params
        }).then(result => {
            this.dialogLoaging = false;
            this.rfc = '';
            this.$refs.form.resetValidation()
            console.log(result.data);
            if (result.data.error) {
              this.dialog = true;
              this.text = result.data.mensaje;
              this.forceRerender();
            } else {
              this.dialog = true;
              this.text = result.data.mensaje;
            }
          },
          error => {
            var r = { error: true, mensaje: "Error de conexión, intenta más tarde." };
            commit('setVisibleDialogCarga', false);
            commit('iniciar', r);
          }
        );
      }else{
        this.captchaerror = true;
      }
    },
    forceRerender(){
      this.rerender += 1;
      this.captcha = false;
    },
    guardar(){
      if(this.password == this.password2){
        this.dialogLoaging = true;
        const params = new URLSearchParams();
        params.append("token", this.token);
        params.append("contrasena", this.password);
        axios({
          method: "POST",
          url: this.urlBase+"kiosco/ejecutarreestablecercontrasena",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: params
        }).then(result => {
            this.dialogLoaging = false;
            console.log(result.data);
            if (result.data.error) {
              this.dialog3 = true;
              this.text3 = result.data.mensaje;
            } else {
              this.dialog2 = true;
              this.text2 = result.data.mensaje;
            }
          },
          error => {
            var r = { error: true, mensaje: "Error de conexión, intenta más tarde." };
            commit('setVisibleDialogCarga', false);
            commit('iniciar', r);
          }
        );
      }else{
        this.dialog = true;
        this.text = "Las contraseñas deben ser igual";
      }
    },
    redirect(){
      window.open("https://atilafinanciera.com/miscreditos/",'_parent');
    }
  },
};
</script>

<style scoped>
.imagen {
  width: 150px;
  height: auto;
  display: inline-block;
}
.centrarBody {
  padding-left: 10%;
  padding-right: 10%;
  margin-bottom: 50px;
}

@media screen and (max-width: 585px) {
  .centrarBody {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>
